import styled, { css } from 'styled-components';

const SectionContainer = styled.div`
  width: 100%;
`;

const SectionTitle = styled.header`
  font: ${props => props.theme.fontWeightHeavy} 24px/120% ${props => props.theme.fontFamilyBody};
  text-transform: uppercase;
  color: ${props => props.theme.bodyColor};
  height: 45px;
  border-bottom: 1px solid ${props => props.theme.secondaryColor};
  margin-top: 60px;
`;

const LwColumnChartStyles = css`
  .recharts-cartesian-axis-tick-value {
    text-transform: uppercase;
    font-size: 14px;
  }

  .recharts-cartesian-grid line {
    stroke: ${props => props.theme.columnChartGridColor};
  }

  .recharts-xAxis {
    .recharts-cartesian-axis-line {
      stroke: ${props => props.theme.primaryColor};
    }
    .recharts-cartesian-axis-tick {
      .recharts-cartesian-axis-tick-line {
        stroke: ${props => props.theme.columnChartGridColor};
      }
      .recharts-cartesian-axis-tick-value {
        fill: ${props => props.theme.secondaryColor};
        text-anchor: end;
        transform: translate(-8px, -16px);
      }
    }
  }

  .recharts-yAxis > .recharts-cartesian-axis-ticks {
    .recharts-cartesian-axis-tick > .recharts-cartesian-axis-tick-value {
      font-weight: ${props => props.theme.fontWeightBold};
      transform: translate(-30px, -12px);
      text-anchor: start;
      fill: ${props => props.theme.columnChartGridColor};
    }
    .recharts-cartesian-axis-tick > .recharts-cartesian-axis-tick-line {
      stroke: ${props => props.theme.columnChartGridColor};
    }
    .recharts-cartesian-axis-tick:first-child > .recharts-cartesian-axis-tick-line {
      stroke: ${props => props.theme.primaryColor};
    }
  }

  ${props => !props.nonFixedBarColor && `
    .recharts-rectangle {
      fill: ${props.theme.secondaryColor};
    }
  `};

  .recharts-rectangle.active {
    fill: ${props => props.theme.bodyColor};
  }
`;

export {
  SectionContainer,
  SectionTitle,
  LwColumnChartStyles,
};
